import {
  NOTES_BATCH_DELETE_REQUEST,
  NOTES_BATCH_DELETE_SUCCESS,
  NOTES_BATCH_DELETE_FAILURE,
  NOTES_FETCH_MANY_REQUEST,
  NOTES_FETCH_MANY_SUCCESS,
  NOTES_FETCH_MANY_FAILURE,
  NOTES_FETCH_REQUEST,
  NOTES_FETCH_SUCCESS,
  NOTES_FETCH_FAILURE,
  NOTES_SAVE_REQUEST,
  NOTES_SAVE_SUCCESS,
  NOTES_SAVE_FAILURE,

  EMPTY_NOTES,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(NOTES_BATCH_DELETE_REQUEST)
    return window.axios.post('/notes', { _method: 'DELETE', ids }).then(response => {
      commit(NOTES_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(NOTES_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1, extraParams = {} }) {
    commit(NOTES_FETCH_MANY_REQUEST)
    return window.axios.get('/notes', { params: { query, page, ...extraParams } }).then(response => {
      commit(NOTES_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(NOTES_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(NOTES_FETCH_REQUEST)
    return window.axios.get(`/notes/${id}`).then(response => {
      commit(NOTES_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(NOTES_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, user) {
    const path = user.id ? `/notes/${user.id}` : '/notes'
    const method = user.id ? 'put' : 'post'

    commit(NOTES_SAVE_REQUEST)
    return window.axios[method](path, user).then(response => {
      commit(NOTES_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(NOTES_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(NOTES_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_NOTES);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
